import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';

export const setReadonlyFields = (payload: State['readonlyFields']): Action => {
  return {
    type: ACTION_TYPES.SET_READONLY_FIELDS,
    payload: [payload, null],
  };
};

export const setPepperUploadDate = (payload: State['readonlyFields']['admin']['pepperUploadDate']): Action => ({
  type: ACTION_TYPES.SET_PEPPER_UPLOAD_DATE,
  payload: [payload, null],
});
